import React, { useState, useEffect } from "react";
import VerifyUserModal from "../../components/VerifyUserModal/VerifyUserModal";
import VideoSection from "./VideoSection/VideoSection";
import NewIntroSection from "./NewIntroSection/NewIntroSection";
import KeyNumbersData from "./KeyNumbers/KeyNumbersData";
import PopularSpaces from "./PopularSpaces/PopularSpaces";
import Steps from "./Steps/Steps";
import RentVision from "./RentVision/RentVision";
import Reviews from "./ReviewsSection/Reviews";
import "./home.css";
import SEOTags from "../../utils/SEOTags";
import { LatestNews } from "./LatestNews/LatestNews";

const OrganizationSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  "@id": "https://www.vakansa.se/#organization",
  name: "Vakansa",
  legalName: "Vakansa AB",
  url: "https://www.vakansa.se",
  logo: {
    "@type": "ImageObject",
    url: "https://www.vakansa.se/images/logo/meta-logo.jpg",
  },
  description:
    "Vakansa grundades med den enkla övertygelsen att det finns tillräckligt många byggnader & lokaler för alla samhällets aktörer - genom delning!",
  foundingDate: "2019",
  founders: [
    {
      "@type": "Person",
      name: "Robin Rushdi Al-Sálehi",
      jobTitle: "Founder & CEO",
      image: "https://www.vakansa.se/images/team/robin.png",
    },
  ],
  address: {
    "@type": "PostalAddress",
    streetAddress: "Tegnergatan 40 b",
    addressLocality: "Uppsala",
    addressRegion: "Uppsala",
    postalCode: "752 27",
    addressCountry: "Sweden",
  },
  contactPoint: {
    "@type": "ContactPoint",
    contactType: "customer support",
    telephone: "[+46] 76 706 56 62",
    email: "info@vakansa.se",
  },
  sameAs: [
    "https://www.facebook.com/Vakansa/",
    "https://www.instagram.com/vakansa.se/",
    "https://www.linkedin.com/company/vakansa/",
  ],
  aggregateRating: {
    "@type": "AggregateRating",
    ratingValue: "5.0",
    bestRating: "5",
    worstRating: "1",
    reviewCount: "19",
  },
  review: [
    {
      "@type": "Review",
      author: { "@type": "Person", name: "Aylin" },
      reviewRating: { "@type": "Rating", ratingValue: "5" },
      reviewBody:
        "Smidig process och vi är tacksamma för hjälpen vi fick med att hitta en bra hyresgäst!",
      datePublished: "2025-05",
    },
    {
      "@type": "Review",
      author: { "@type": "Person", name: "Pilar Mercedes Ravandoni" },
      reviewRating: { "@type": "Rating", ratingValue: "5" },
      reviewBody:
        "Redan från dag ett fick jag stort förtroende för Robin. Hans tydliga, raka och samtidigt varma sätt att kommunicera skapade en trygghet som gjorde hela processen både enkel och inspirerande. Det uppstod ett fint flöde redan efter vårt första samtal, och resultatet blev att jag idag delar kontor med ett trevligt gäng. Tack, Robin för ditt engagemang, din lyhördhet och för att du verkligen gör skillnad.",
      datePublished: "2025-10",
    },
    {
      "@type": "Review",
      author: { "@type": "Person", name: "Lana Fierro Murphy" },
      reviewRating: { "@type": "Rating", ratingValue: "5" },
      reviewBody:
        "Jättebra samarbete med Vakansa som hjälpt oss skaffa en ny hyresgäst! Snabb och hjälpsam återkoppling vid behov.",
      datePublished: "2025-02",
    },
    {
      "@type": "Review",
      author: { "@type": "Person", name: "Gassan Jaber" },
      reviewRating: { "@type": "Rating", ratingValue: "5" },
      reviewBody:
        "Enkelt och bra att jobba med Vakansa. De hjälpte oss att hitta någon till våra lokaler för att optimera dem. Fick hjälp med hela processen. Bästa med det hela så kostade det inget förens allt var packat och klart! Win-win!",
      datePublished: "2024-02",
    },
    {
      "@type": "Review",
      author: { "@type": "Person", name: "Mia Wahlström" },
      reviewRating: { "@type": "Rating", ratingValue: "5" },
      reviewBody:
        "Tack Vakansa - plötsligt var det enkelt att hitta en kontorslokal som var perfekt för våra behov och vår budget!",
      datePublished: "2025-02",
    },
    {
      "@type": "Review",
      author: { "@type": "Person", name: "Hans Hallengren" },
      reviewRating: { "@type": "Rating", ratingValue: "5" },
      reviewBody:
        "Vakansa hjälpte mig att hitta en lokal i Uppsala till ett riktigt bra pris för min budget. Jag behövde ett rum att breda ut mig i under 2 veckor för att skapa utbildningsmaterial utan att behöva plocka undan efter mig varje dag. Tacksam att det gick att ordna snabbt och smidigt.",
      datePublished: "2022-02",
    },
  ],
};

export default function Home({ verifyUser = false }) {
  const [showVerifyModal, setShowVerifyModal] = useState(verifyUser);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, []);

  return (
    <main>
      <SEOTags
        title={"På Vakansa kan du hyra lokal eller hyra ut lokaler!"}
        description={
          "Hyr lokal eller hyra ut lokal på Vakansa. Hitta flexibla lokaler i andrahand och bidra till hållbar stadsutveckling – smidigt för hyresgäster och hyresvärdar."
        }
        canonicalUrl={"/"}
        ogImage={"/images/logo/meta-logo.jpg"}
        structuredData={OrganizationSchema}
      />
      <NewIntroSection />
      <div className="home-main-container">
        <KeyNumbersData />
        <PopularSpaces />
        <VideoSection />
        <Steps />
        <Reviews />
        <RentVision />
        <LatestNews />
        {showVerifyModal && (
          <VerifyUserModal setShowModal={setShowVerifyModal} />
        )}
      </div>
    </main>
  );
}
